import type { InputProps } from 'ui/components/primitives';

export enum SEARCH_INPUT_CONST {
  TEST_ID = 'search-input',
}

export type SearchInputProps = Omit<InputProps, 'onChange'> & {
  listId?: string;
  onChangeSearch?: (searchValue: string) => void;
  onClear?: () => void;
  onSearchClick?: (event: React.FormEvent<HTMLFormElement>) => void;
  type?: 'search' | 'text';
  toggleFocus?: (focus: boolean) => void;
};

export type UseSearchProps = Omit<SearchInputProps, 'listId'>;
